import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { AuditedPersonSvg } from './AuditedPersonSvg'

export const EaAuditPersonIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={AuditedPersonSvg} {...props} />
)
